// Keep in sync with app/lib/enums/brand_sku_mapper_v2_enums.py
// Status / review status / action are identical to V1.

export const BrandSkuMapperV2RunStatus = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
};

export const BrandSkuMapperV2ReviewStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  NO_MATCH: 'NO_MATCH',
};

export const BrandSkuMapperV2ReviewAction = {
  APPROVE: 'approve',
  REJECT: 'reject',
  NO_MATCH: 'no_match',
  PICK: 'pick',
};

export const BRAND_SKU_MAPPER_V2_REVIEW_STATUS_TABS = [
  { key: '', label: 'All' },
  { key: BrandSkuMapperV2ReviewStatus.PENDING, label: 'Pending' },
  { key: BrandSkuMapperV2ReviewStatus.APPROVED, label: 'Approved' },
  { key: BrandSkuMapperV2ReviewStatus.REJECTED, label: 'Rejected' },
  { key: BrandSkuMapperV2ReviewStatus.NO_MATCH, label: 'No Match' },
];

// Tier from the calibrated scorer.
export const BrandSkuMapperV2Tier = {
  HIGH: 'high',
  LOW: 'low',
  NO_MATCH: 'no_match',
};

export const BrandSkuMapperV2RunRequestField = {
  REMAINING_ONLY: 'remaining_only',
  MODEL_VERSION: 'model_version',
  MAX_PRODUCTS: 'max_products',
  BRAND_ID: 'brand_id',
  DISTRIBUTOR_ID: 'distributor_id',
  MANUFACTURER_ID: 'manufacturer_id',
  POPULATION: 'population',
  // Population-specific toggle: has_thumbnail for BRAND_VERIFIED, has_brand
  // for BRAND_NOT_VERIFIED. Unused for GMV.
  SWITCH: 'switch',
  // Second, independent toggle for the two unmapped populations.
  DP_PARTNER: 'dp_partner',
};

// Which mutually-exclusive vendor-product population a run/query scopes to.
// GMV = has real Snowflake transactional volume last month. The other two
// cover everything else still unmapped, split by brand-verification state;
// each is further narrowed by SWITCH + DP_PARTNER.
export const BrandSkuMapperV2Population = {
  GMV: 'gmv',
  BRAND_VERIFIED: 'brand_verified',
  BRAND_NOT_VERIFIED: 'brand_not_verified',
};

// GMV is its own route (see AppContainer.jsx); the other two share the
// "unmapped" route and switch population via local state.
export const BRAND_SKU_MAPPER_V2_POPULATION_TABS = [
  { key: BrandSkuMapperV2Population.GMV, label: 'All GMV Products' },
  { key: BrandSkuMapperV2Population.BRAND_VERIFIED, label: 'Brand Verified' },
  { key: BrandSkuMapperV2Population.BRAND_NOT_VERIFIED, label: 'Brand Not Verified' },
];
